import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { themePalette } from '@theme/muiTheme';
import { FilterIcon } from '@utils/iconsDefs';

export const StyledFilterIcon = styled(FilterIcon)``;
export const StyledFilterButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== '$isActive' && prop !== '$isDisabled',
})<{
  $isActive: boolean;
  $isDisabled: boolean;
}>`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid
    ${({ $isActive, $isDisabled }) => {
      if ($isDisabled) {
        return themePalette.grey[500];
      }
      if ($isActive) {
        return themePalette.grey[900];
      }
      return themePalette.grey[700];
    }};

  &:hover {
    border: 1px solid
      ${({ $isDisabled }) =>
        $isDisabled ? themePalette.grey[500] : themePalette.grey[800]};
  }
`;
